export interface Comic {
  id: string;
  title: string;
  author: string;
  genre: string;
  tags: string[];
  rating: number;
  episodes: number;
  status: string;
  views: string;
  desc: string;
  cover: string;
}

export const comics: Comic[] = [
  {
    id: "neon-district",
    title: "霓虹街区",
    author: "林相浩",
    genre: "奇幻异能",
    tags: ["都市异能", "赛博", "群像"],
    rating: 9.6,
    episodes: 128,
    status: "连载中",
    views: "2380万",
    desc: "在霓虹与数据洪流交织的都市里，觉醒异能者的少年少女们被迫卷入各方势力的博弈，在秩序与失控之间寻找自己的位置。",
    cover: "https://readdy.ai/api/search-image?query=Animated%20Korean%20webtoon%20poster%20of%20a%20futuristic%20neon%20city%20at%20night%20with%20a%20young%20protagonist%20in%20a%20glowing%20hoodie%2C%20cyberpunk%20street%20filled%20with%20vibrant%20pink%20and%20orange%20neon%20signs%2C%20dynamic%20anime%20comic%20illustration%20style%2C%20high%20energy%2C%20warm%20color%20palette%2C%20clean%20composition%2C%20cinematic%20lighting&width=500&height=720&seq=poster-neon&orientation=portrait",
  },
  {
    id: "crimson-phoenix",
    title: "朱雀学院",
    author: "崔智恩",
    genre: "校园奇幻",
    tags: ["校园", "魔法", "成长"],
    rating: 9.4,
    episodes: 96,
    status: "连载中",
    views: "1920万",
    desc: "普通转学生误入专收异兽使的朱雀学院，在一场场惊心动魄的试炼中，逐渐揭开这座学园背后隐藏的百年秘密。",
    cover: "https://readdy.ai/api/search-image?query=Animated%20Korean%20webtoon%20poster%20of%20a%20mystical%20academy%20with%20a%20red%20crimson%20phoenix%20soaring%20above%20an%20ornate%20school%20courtyard%2C%20young%20student%20with%20magical%20aura%2C%20fantasy%20anime%20illustration%2C%20warm%20orange%20and%20gold%20tones%2C%20dramatic%20composition%2C%20vibrant%20colorful%20background&width=500&height=720&seq=poster-phoenix&orientation=portrait",
  },
  {
    id: "twelfth-night",
    title: "契约·第十二夜",
    author: "姜正勋",
    genre: "悬疑奇幻",
    tags: ["契约", "推理", "反转"],
    rating: 9.8,
    episodes: 74,
    status: "连载中",
    views: "2610万",
    desc: "当倒计时进入第十二个夜晚，契约者必须在梦境与现实的夹缝中找出真正的规则，每一次选择都将改写所有人的命运。",
    cover: "https://readdy.ai/api/search-image?query=Animated%20Korean%20webtoon%20poster%20of%20a%20dark%20mysterious%20moonlit%20night%20scene%20with%20a%20hooded%20figure%20holding%20a%20glowing%20contract%20scroll%2C%20magical%20clock%20and%20moon%20in%20background%2C%20suspenseful%20fantasy%20anime%20style%2C%20deep%20teal%20and%20amber%20color%20contrast%2C%20cinematic%20mystery%20atmosphere&width=500&height=720&seq=poster-twelfth&orientation=portrait",
  },
  {
    id: "doomsday-station",
    title: "末日起点站",
    author: "尹瑞英",
    genre: "末世生存",
    tags: ["末世", "生存", "冒险"],
    rating: 9.3,
    episodes: 152,
    status: "已完结",
    views: "3050万",
    desc: "灾难降临后，一群幸存者以废弃车站为据点，在资源稀缺与异变蔓延的绝境中，坚守着人类最后的文明火种。",
    cover: "https://readdy.ai/api/search-image?query=Animated%20Korean%20webtoon%20poster%20of%20a%20group%20of%20survivors%20standing%20in%20front%20of%20a%20ruined%20train%20station%20after%20an%20apocalypse%2C%20embers%20and%20ashes%20in%20the%20air%2C%20post%20apocalyptic%20anime%20illustration%2C%20warm%20coral%20and%20dark%20amber%20tone%2C%20hopeful%20yet%20grim%20mood%2C%20dynamic%20composition&width=500&height=720&seq=poster-doomsday&orientation=portrait",
  },
  {
    id: "spirit-kitchen",
    title: "灵川料理屋",
    author: "朴秀彬",
    genre: "治愈日常",
    tags: ["治愈", "美食", "日常"],
    rating: 9.5,
    episodes: 88,
    status: "连载中",
    views: "1740万",
    desc: "一间只在深夜亮灯的小小料理屋，用一道料理治愈一位客人，也慢慢治愈着失去味觉的店主自己的心。",
    cover: "https://readdy.ai/api/search-image?query=Animated%20Korean%20webtoon%20poster%20of%20a%20cozy%20warm%20night%20restaurant%20kitchen%20with%20steaming%20delicious%20food%20on%20a%20wooden%20table%2C%20soft%20lantern%20light%2C%20gentle%20cooking%20scene%2C%20healing%20slice%20of%20life%20anime%20style%2C%20warm%20golden%20and%20cream%20palette%2C%20comforting%20peaceful%20atmosphere&width=500&height=720&seq=poster-kitchen&orientation=portrait",
  },
  {
    id: "echo-stardust",
    title: "星屑回响",
    author: "李叙英",
    genre: "恋爱科幻",
    tags: ["恋爱", "科幻", "催泪"],
    rating: 9.2,
    episodes: 60,
    status: "连载中",
    views: "1480万",
    desc: "能听见星星声音的女孩，与守护她的宇航员少年，跨越光年的距离，用一段段讯号拼出彼此的心意。",
    cover: "https://readdy.ai/api/search-image?query=Animated%20Korean%20webtoon%20poster%20of%20a%20girl%20and%20a%20young%20astronaut%20looking%20at%20a%20starry%20galaxy%20sky%20with%20shooting%20stars%2C%20romantic%20science%20fiction%20anime%20illustration%2C%20soft%20dreamy%20glow%2C%20warm%20violet%20and%20gold%20cosmic%20tones%2C%20emotional%20tender%20atmosphere&width=500&height=720&seq=poster-stardust&orientation=portrait",
  },
  {
    id: "outback-detective",
    title: "无人区侦探",
    author: "金道贤",
    genre: "悬疑推理",
    tags: ["犯罪", "推理", "硬核"],
    rating: 9.7,
    episodes: 104,
    status: "连载中",
    views: "2160万",
    desc: "游走于法律灰色地带的独行侦探，凭着一双能识破一切谎言的眼睛，在无人愿意踏足的角落里揭开一桩桩真相。",
    cover: "https://readdy.ai/api/search-image?query=Animated%20Korean%20webtoon%20poster%20of%20a%20sharply%20dressed%20male%20detective%20in%20a%20rainy%20noir%20alley%20with%20a%20trench%20coat%20and%20magnifying%20glass%2C%20moody%20crime%20mystery%20anime%20style%2C%20deep%20charcoal%20and%20amber%20streetlamp%20tones%2C%20tense%20dramatic%20atmosphere%2C%20sharp%20character%20focus&width=500&height=720&seq=poster-detective&orientation=portrait",
  },
  {
    id: "tide-hunter",
    title: "潮汐猎手",
    author: "赵允真",
    genre: "动作冒险",
    tags: ["动作", "冒险", "海洋"],
    rating: 9.1,
    episodes: 132,
    status: "连载中",
    views: "1870万",
    desc: "在由海洋掌控的世界里，年轻的猎潮者驾驶改装舰艇，对抗深海巨兽，只为守住家园最后一片安宁。",
    cover: "https://readdy.ai/api/search-image?query=Animated%20Korean%20webtoon%20poster%20of%20a%20young%20adventurer%20riding%20a%20wave%20with%20a%20high%20tech%20spear%20against%20a%20giant%20sea%20monster%20in%20a%20stormy%20ocean%2C%20action%20adventure%20anime%20illustration%2C%20splashing%20water%20and%20spray%2C%20warm%20coral%20and%20teal%20dynamic%20tones%2C%20high%20motion%20composition&width=500&height=720&seq=poster-tide&orientation=portrait",
  },
  {
    id: "one-eye-shinji",
    title: "独眼真嗣",
    author: "朴尚佑",
    genre: "动作热血",
    tags: ["热血", "格斗", "复仇"],
    rating: 9.0,
    episodes: 118,
    status: "已完结",
    views: "2530万",
    desc: "失去一只眼睛的拳手回到地下擂台，用拳头一点一点夺回属于自己的尊严，也在疼痛中找到了活下去的意义。",
    cover: "https://readdy.ai/api/search-image?query=Animated%20Korean%20webtoon%20poster%20of%20a%20scarred%20one%20eyed%20boxer%20with%20bandaged%20hands%20in%20a%20dark%20underground%20fighting%20arena%20with%20floodlights%2C%20intense%20martial%20arts%20anime%20style%2C%20dramatic%20orange%20rim%20lighting%2C%20sweat%20and%20motion%20energy%2C%20powerful%20heroic%20stance&width=500&height=720&seq=poster-shinji&orientation=portrait",
  },
  {
    id: "pink-alert",
    title: "粉色警报",
    author: "韩多恩",
    genre: "恋爱甜宠",
    tags: ["甜宠", "校园", "欢喜冤家"],
    rating: 8.9,
    episodes: 82,
    status: "连载中",
    views: "1620万",
    desc: "一场乌龙告白让全校闻名的「冷静学姐」和「麻烦学弟」被绑在了一根红线两端，从互相嫌弃到渐渐心动。",
    cover: "https://readdy.ai/api/search-image?query=Animated%20Korean%20webtoon%20poster%20of%20a%20blushing%20high%20school%20girl%20and%20a%20playful%20boy%20under%20a%20cherry%20blossom%20tree%20with%20floating%20pink%20petals%2C%20sweet%20romance%20comedy%20anime%20style%2C%20soft%20warm%20pink%20and%20cream%20tones%2C%20lighthearted%20cheerful%20mood%2C%20clean%20cute%20composition&width=500&height=720&seq=poster-pink&orientation=portrait",
  },
  {
    id: "cloud-architect",
    title: "云端建筑师",
    author: "成智惠",
    genre: "科幻脑洞",
    tags: ["赛博", "脑洞", "反转"],
    rating: 9.3,
    episodes: 66,
    status: "连载中",
    views: "1390万",
    desc: "一名能「重建世界」的梦境建筑师发现，自己精心设计的每一个世界，都在悄悄与现实产生诡异的重叠。",
    cover: "https://readdy.ai/api/search-image?query=Animated%20Korean%20webtoon%20poster%20of%20an%20architect%20holding%20a%20glowing%20floating%20city%20model%20in%20the%20clouds%20at%20sunset%2C%20surreal%20cyberpunk%20science%20fiction%20anime%20style%2C%20warm%20amber%20and%20golden%20light%2C%20dreamy%20mind%20bending%20atmosphere%2C%20creative%20abstract%20composition&width=500&height=720&seq=poster-cloud&orientation=portrait",
  },
  {
    id: "mist-dreamer",
    title: "雾都食梦者",
    author: "郑承雅",
    genre: "奇幻日常",
    tags: ["奇幻", "日常", "温情"],
    rating: 9.2,
    episodes: 54,
    status: "连载中",
    views: "1210万",
    desc: "在终年被浓雾笼罩的城市里，食梦者靠收集人们的噩梦维生，却在一次次潜入梦境时，读到了城市深处的孤独。",
    cover: "https://readdy.ai/api/search-image?query=Animated%20Korean%20webtoon%20poster%20of%20a%20mysterious%20hooded%20dream%20eater%20walking%20through%20a%20misty%20fog%20covered%20city%20street%20with%20floating%20dream%20bubbles%2C%20whimsical%20fantasy%20anime%20style%2C%20soft%20warm%20grey%20and%20gold%20tones%2C%20ethereal%20gentle%20mood%2C%20storybook%20atmosphere&width=500&height=720&seq=poster-mist&orientation=portrait",
  },
];

export interface RankItem {
  rank: number;
  comic: Comic;
  trend: string;
  hot: number;
}

export const ranking: RankItem[] = [
  { rank: 1, comic: comics[2], trend: "+2", hot: 2610 },
  { rank: 2, comic: comics[0], trend: "持平", hot: 2380 },
  { rank: 3, comic: comics[6], trend: "+1", hot: 2160 },
  { rank: 4, comic: comics[3], trend: "-2", hot: 3050 },
  { rank: 5, comic: comics[4], trend: "+3", hot: 1740 },
  { rank: 6, comic: comics[8], trend: "新入", hot: 2530 },
  { rank: 7, comic: comics[7], trend: "+1", hot: 1870 },
  { rank: 8, comic: comics[9], trend: "-1", hot: 1620 },
];

export const categories: { name: string; icon: string; desc: string; count: number }[] = [
  { name: "奇幻异能", icon: "ri-magic-line", desc: "觉醒、魔法与超自然力量", count: 128 },
  { name: "悬疑推理", icon: "ri-search-eye-line", desc: "烧脑反转与真相追踪", count: 96 },
  { name: "恋爱甜宠", icon: "ri-heart-3-line", desc: "心动日常与甜蜜拉扯", count: 154 },
  { name: "动作热血", icon: "ri-flashlight-line", desc: "战斗、格斗与成长", count: 87 },
  { name: "末世生存", icon: "ri-flag-line", desc: "绝境求生与文明坚守", count: 42 },
  { name: "科幻脑洞", icon: "ri-rocket-2-line", desc: "赛博与超现实想象", count: 73 },
  { name: "治愈日常", icon: "ri-cup-line", desc: "温情陪伴与生活小事", count: 110 },
];

export const newReleases: Comic[] = [comics[5], comics[10], comics[11], comics[1], comics[9], comics[4]];

export const siteInfo = {
  brand: "漫潮",
  slogan: "韩国动态漫画精选榜",
  domain: "https://korepops.github.io/",
  contactEmail: "hello@manchao.example.com",
  intro:
    "漫潮是一个专注韩国动态漫画推荐与排行的内容站点。我们持续追踪最新人气作品与高口碑佳作，按题材整理成清晰的榜单与专题，帮你用最短的时间发现最值得追的漫画，从此追更不迷路。",
  principles: [
    "实事求是：所有推荐与榜单均以真实人气、评分与讨论热度为依据。",
    "题材多元：从奇幻悬疑到恋爱热血，覆盖主流与冷门优秀作品。",
    "持续更新：榜单与新作速递保持定期刷新，紧跟追更节奏。",
  ],
};

export const faqs: { q: string; a: string }[] = [
  {
    q: "什么是韩国动态漫画？",
    a: "韩国动态漫画（动态漫）是在传统漫画基础上加入分镜动画、配音、音效与镜头运镜的数字漫画形式，阅读体验介于漫画与动画之间，深受追更党的喜爱。",
  },
  {
    q: "榜单数据多久更新一次？",
    a: "人气榜单通常每周更新一次，结合各平台热度、评分与读者讨论量综合得出；热门作品精选与分类页则会随新作上线与口碑变化滚动调整。",
  },
  {
    q: "如何快速找到自己想看的题材？",
    a: "你可以在首页的分类板块中，按奇幻、悬疑、恋爱、热血、末世、科幻、治愈等题材快速筛选；也可以直接使用顶部搜索框输入作品名或关键词。",
  },
  {
    q: "榜单里的作品在哪里可以观看？",
    a: "榜单仅提供推荐与索引信息。你可以根据每部作品的海报与简介，在对应的正版漫画平台搜索书名进行阅读，漫潮不提供在线观看内容。",
  },
  {
    q: "为什么有些作品标注「已完结」，有些是「连载中」？",
    a: "标签代表作品当前的实际更新状态。「已完结」可放心一次性追完，「连载中」则需要按平台更新节奏追更，我们会同步标注最新进度。",
  },
  {
    q: "如何向我推荐冷门但优秀的作品？",
    a: "欢迎通过页面底部联系邮箱向我们投稿推荐。只要作品口碑扎实、画面与剧情在线，我们会纳入审核并尽量收入精选榜单。",
  },
];